import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"lg":"9"}},[_c(VIcon,{staticClass:"mb-5",attrs:{"color":"success","size":"80"}},[_vm._v("fas fa-check-circle")]),(_vm.prevRoute?.name == 'home')?_c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("confirmedPage.1"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("confirmedPage.2"))+" ")])]):_c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("confirmedPage.3"))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }